<template>
	<div>
		<personal-profile-data-view
			:editable="editable"
			:personal-data="formData.personalData"
			@edition-status="personalDataEditionStatus"
		></personal-profile-data-view>

		<organization-names-profile-data-view
			v-show="isSubsidiary"
			:title="'Dane podmiotu'"
			:editable="false"
			:organization-names-data="formData.parentOrganizationNamesData"
			:is-subsidiary="isSubsidiary"
		></organization-names-profile-data-view>

		<organization-names-profile-data-view
			:title="getSubBidderOrganizationHeader"
			:editable="editable"
			:organization-names-data="formData.organizationNamesData"
			:is-subsidiary="isSubsidiary"
			@edition-status="organizationNamesDataEditionStatus"
		></organization-names-profile-data-view>

		<v-layout row class="mb-4">
			<v-flex xs3/>
			<v-flex xs5>
				<v-alert
					:value="showAlert"
					type="info"
					outline
				>{{alertMessage}}
				</v-alert>
			</v-flex>
		</v-layout>

		<v-layout row v-if="editable">
			<v-flex xs4/>
			<v-flex xs3>
				<v-btn block color="primary" dark class="mt-2 mb-5" @click="save">Zapisz zmiany</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Profile} from "../../../../api/generated/Profile";
	import PersonalProfileDataView from "./components/PersonalProfileDataView";
	import OrganizationNamesProfileDataView from "./components/OrganizationNamesProfileDataView";

	export default {
		name: "SubBidderProfileView",
		components: {
			PersonalProfileDataView,
			OrganizationNamesProfileDataView
		},

		data() {
			return {
				formData: {},
				personalDataEditable: false,
				organizationNamesDataEditable: false,
				showAlert: false,
				alertMessage: ''
			};
		},

		props: {
			editable: {
				default: true,
			},
		},

		computed: {
			isSubsidiary() {
				return this.roles.isSubBidder() && this.formData.subBidderType === 'SUBSIDIARY';
			},

			getSubBidderOrganizationHeader() {
				return this.isSubsidiary ? 'Dane podmiotu zależnego' : 'Dane podmiotu';
			},
		},

		methods: {
			personalDataEditionStatus(status) {
				this.personalDataEditable = status;
			},

			organizationNamesDataEditionStatus(status) {
				this.organizationNamesDataEditable = status;
			},

			save () {
				if (this.personalDataEditable || this.organizationNamesDataEditable) {
					this.alertMessage = 'Aby zapisać zmiany, skończ edycję danych!';
					this.showAlert = true;
				} else {
					this.showAlert = false;
					Profile.putSubBidderProfile(this, this.formData, successResponse => {
						this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
						this.refresh();
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmiany", errorResponse);
					});
				}
			},

			refresh () {
				Profile.getSubBidderProfile(this, this.$route.params.userId, successResponse => {
					this.formData = successResponse;
				}, errorResponse => {
					if (errorResponse.error === "access_denied") {
						this.$router.push("/forbidden");
					} else {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych profilowych", errorResponse);
					}
				});
			}
		},

		created () {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
